import React, { useEffect, useState } from 'react';
import { fetchReceipt, fetchReceiptPdf } from './receiptUtils';
import './CheckPage.css';

// Публічна сторінка квитанції /p/<токен> (вигляд check.monobank.ua).
// Дані беремо з Realtime Database за токеном (їх зберігає TransactionsDetails).

// "25.07.2026 16:43" → "2026-07-25 16:43"
function toIsoLike(dateTime) {
  const m = /^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}:\d{2})/.exec(dateTime || '');
  return m ? `${m[3]}-${m[2]}-${m[1]} ${m[4]}` : dateTime || '—';
}

function formatAmount(n) {
  const v = Number(n) || 0;
  return `${v.toLocaleString('uk-UA', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 })} ₴`;
}

function maskCard(d) {
  const s = String(d || '').replace(/\D/g, '');
  return s.length < 10 ? s : `${s.slice(0, 6)}******${s.slice(-4)}`;
}

// Шрифти лежать у public/ — у CSS CRA абсолютні url не резолвить, тому через <style>
const FONTS_CSS = `@font-face { font-family: Inter; font-weight: 400; src: url(/Inter-Regular.ttf) format("truetype"); }
@font-face { font-family: Inter; font-weight: 600; src: url(/Inter-SemiBold.ttf) format("truetype"); }
@font-face { font-family: Inter; font-weight: 700 800; src: url(/Inter-Bold.ttf) format("truetype"); }`;

// Хрестик закриття попапа — як на check.monobank.ua
const CLOSE_ICON = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgOC42TDIuMiAxMy40QzEuOTgzMzMgMTMuNjE2NyAxLjcxNjY3IDEzLjcyNSAxLjQgMTMuNzI1QzEuMDgzMzMgMTMuNzI1IDAuODE2NjY3IDEzLjYxNjcgMC42IDEzLjRDMC4zODMzMzQgMTMuMTgzMyAwLjI3NSAxMi45MTY3IDAuMjc1IDEyLjZDMC4yNzUgMTIuMjgzMyAwLjM4MzMzNCAxMi4wMTY3IDAuNiAxMS44TDUuNCA3TDAuNiAyLjJDMC4zODMzMzQgMS45ODMzMyAwLjI3NSAxLjcxNjY3IDAuMjc1IDEuNEMwLjI3NSAxLjA4MzMzIDAuMzgzMzM0IDAuODE2NjY2IDAuNiAwLjU5OTk5OUMwLjgxNjY2NyAwLjM4MzMzMyAxLjA4MzMzIDAuMjc1IDEuNCAwLjI3NUMxLjcxNjY3IDAuMjc1IDEuOTgzMzMgMC4zODMzMzMgMi4yIDAuNTk5OTk5TDcgNS40TDExLjggMC41OTk5OTlDMTIuMDE2NyAwLjM4MzMzMyAxMi4yODMzIDAuMjc1IDEyLjYgMC4yNzVDMTIuOTE2NyAwLjI3NSAxMy4xODMzIDAuMzgzMzMzIDEzLjQgMC41OTk5OTlDMTMuNjE2NyAwLjgxNjY2NiAxMy43MjUgMS4wODMzMyAxMy43MjUgMS40QzEzLjcyNSAxLjcxNjY3IDEzLjYxNjcgMS45ODMzMyAxMy40IDIuMkw4LjYgN0wxMy40IDExLjhDMTMuNjE2NyAxMi4wMTY3IDEzLjcyNSAxMi4yODMzIDEzLjcyNSAxMi42QzEzLjcyNSAxMi45MTY3IDEzLjYxNjcgMTMuMTgzMyAxMy40IDEzLjRDMTMuMTgzMyAxMy42MTY3IDEyLjkxNjcgMTMuNzI1IDEyLjYgMTMuNzI1QzEyLjI4MzMgMTMuNzI1IDEyLjAxNjcgMTMuNjE2NyAxMS44IDEzLjRMNyA4LjZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K';

// Випадковий "Error code" — 32 hex-символи
function randomTraceId() {
  return Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
}

export default function CheckPage() {
  const token = window.location.pathname.split('/')[2] || '';
  const [state, setState] = useState('loading'); // loading | ok | missing | error
  const [data, setData] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(true);
  const [traceId] = useState(randomTraceId);

  useEffect(() => {
    document.title = 'monobank | Квитанція';
    let cancelled = false;
    fetchReceipt(token)
      .then((val) => {
        if (cancelled) return;
        if (val) { setData(val); setState('ok'); } else setState('missing');
      })
      .catch(() => { if (!cancelled) setState('error'); });
    return () => { cancelled = true; };
  }, [token]);

  async function downloadPdf() {
    if (downloading) return;
    setDownloading(true);
    try {
      const blob = await fetchReceiptPdf(data);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `receipt_${data.receiptNumber || token}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (e) {
      console.error(e);
      alert('Не вдалося завантажити квитанцію');
    } finally {
      setDownloading(false);
    }
  }

  return (
    <div className="check-page">
      <style>{FONTS_CSS}</style>
      {document.referrer.startsWith(window.location.origin) && (
        <button type="button" onClick={() => window.history.back()}
          style={{ alignSelf: 'flex-start', margin: '16px 16px 0', background: 'none', border: 0, fontSize: 16, cursor: 'pointer' }}>
          ← Назад
        </button>
      )}
      <main id="main">
        {state === 'loading' && <div className="loader-container"><div className="loader" /></div>}
        {state === 'missing' && popupOpen && (
          <InvalidLinkPopup traceId={traceId} onClose={() => setPopupOpen(false)} />
        )}
        {state === 'error' && (
          <div className="check-center">Не вдалося завантажити квитанцію</div>
        )}
        {state === 'ok' && (
          <div className="page-container">
            <div className="page-header">
              <div className="logo"><img src="/check-logo.svg" alt="monobank | Universal Bank" className="logo-image" /></div>
            </div>
            <div id="page-content" className="page-content">
              <img src="/check-success.svg" className="status-icon" alt="" />
              <div className="status-title">Платіж успішний</div>
              <div className="status-subtitle">Квитанція {data.receiptNumber}</div>
              <div className="split-line" />
              <div className="list-content">
                <Row label="Відправник" value={data.senderName || '—'} />
                {/* Переказ на картку — маска картки; платіж за IBAN (картки немає) — назва отримувача, напр. «ФОП …» */}
                <Row label="Отримувач" value={maskCard(data.recipientCard) || data.recipientName || '—'} />
                <Row label="Сума" value={formatAmount(data.amount)} />
                <Row label="Дата" value={toIsoLike(data.dateTime)} />
                <Row label="Призначення" value="Переказ коштів" />
              </div>
              <button className="view-button" onClick={downloadPdf} disabled={downloading}>
                {downloading ? <div className="loader" /> : 'Переглянути квитанцію'}
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

function InvalidLinkPopup({ traceId, onClose }) {
  return (
    <div className="popup-holder">
      <div className="popup">
        <div className="popup-scroller">
          <div className="popup-content">
            <div className="popup-header">
              <div className="popup-header-title">Invalid link</div>
              <div className="popup-close-container">
                <button className="popup-close" aria-label="Close" title="Close" onClick={onClose}>
                  <img src={CLOSE_ICON} className="popup-close-icon" alt="" />
                </button>
              </div>
            </div>
            <div className="popup-body">
              <div className="popup-text">
                Please ask the sender to send a new link
                <div className="popup-trace-id">
                  Error code: <span className="popup-trace-id-value">{traceId}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="list-item">
      <div className="list-item-label">{label}</div>
      <div className="list-item-value">{value}</div>
    </div>
  );
}
